import React from 'react';
import loadable from '@teetsh/app/src/utils/loadable';
import Spinner from '@teetsh/app/src/components/Spinner/ScreenSpinner';

export default loadable(() => import('./LivretEvalEleve'), {
  fallback: <Spinner />,
});
